/* ===========================================================================
   Customer reviews: a compact teaser in the page, the full review in a modal.

   The box beside the deck (.pnsn-quote / .pnah-quote) used to print two
   hard-coded Discogs lines cycled by window.PNQuotes. It now carries Judge.me's
   31 reviews, printed into #pn-reviews-data by pn-turntable-mount.liquid
   straight from Judge.me's own shop metafields — nothing fetched, nothing
   summarised, nothing invented.

   Rue, 2026-09-27: a long review made the in-flow block tall enough to crowd
   the deck and the tracklist at narrow widths. So the page keeps a short teaser
   of fixed height and the whole review opens in a dialog on <body>, where no
   product-page column can clip it.

   The legacy Discogs snippet is gone from both product sections, so there is
   no data-quotes for window.PNQuotes to read and nothing of its own to write.
   =========================================================================== */
(function () {
  'use strict';
  var DATA, STATS = window.PN_REVIEW_STATS || {};
  try { DATA = JSON.parse(document.getElementById('pn-reviews-data').textContent); }
  catch (e) { return; }
  if (!DATA || !DATA.length) return;

  var DWELL = 7000;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SELLER = STATS.reviews_url || '';

  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"]/g, function(c){
    return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
  function when(iso){
    var d = new Date(iso);
    return isNaN(d) ? '' : d.toLocaleDateString('en-CA', { year:'numeric', month:'short', day:'numeric' });
  }
  function stars(n){ return new Array((n|0) + 1).join('★'); }
  function meta(r){
    return esc(r.n) + (r.v ? ' · Verified buyer' : '') +
      (when(r.d) ? ' · ' + esc(when(r.d)) : '') +
      (r.p ? ' · ' + esc(r.p) : '') + ' · Judge.me';
  }

  /* ——— the dialog, once, on <body> so nothing can clip it ——— */
  var modal, mTitle, mBody, lastFocus = null;
  function buildModal(){
    modal = document.createElement('div');
    modal.className = 'pn-rvm';
    modal.hidden = true;
    modal.innerHTML =
      '<div class="pn-rvm__scrim" data-rvm-close></div>' +
      '<div class="pn-rvm__panel" role="dialog" aria-modal="true" aria-labelledby="pn-rvm-title">' +
        '<button class="pn-rvm__x" type="button" data-rvm-close aria-label="Close review">Close ✕</button>' +
        '<h2 class="pn-rvm__title" id="pn-rvm-title">Customer review</h2>' +
        '<div class="pn-rvm__body"></div>' +
        (SELLER ? '<a class="pn-rvm__link" href="' + esc(SELLER) + '" target="_blank" rel="noopener">' +
          'All Paranoise reviews on Discogs</a>' : '') +
      '</div>';
    document.body.appendChild(modal);
    mBody = modal.querySelector('.pn-rvm__body');
    mTitle = modal.querySelector('.pn-rvm__title');
    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-rvm-close]')) closeModal();
    });
    modal.addEventListener('keydown', function (e) {
      if (e.key === 'Escape'){ e.preventDefault(); closeModal(); return; }
      if (e.key !== 'Tab') return;
      var f = modal.querySelectorAll('button, a[href]');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first){ e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last){ e.preventDefault(); first.focus(); }
    });
  }
  function openModal(r, opener, onClose){
    if (!modal) buildModal();
    lastFocus = opener; modal.__onClose = onClose;
    mTitle.textContent = (r.r|0) + ' out of 5 — ' + (r.p ? r.p : 'Paranoise');
    mBody.innerHTML =
      '<div class="pn-rvm__stars" aria-hidden="true">' + stars(r.r) + '</div>' +
      (r.t ? '<h3 class="pn-rvm__sub">' + esc(r.t) + '</h3>' : '') +
      '<p class="pn-rvm__text">' + esc(r.b) + '</p>' +
      '<p class="pn-rvm__meta">' + meta(r) + '</p>';
    modal.hidden = false;
    document.documentElement.classList.add('pn-rvm-open');
    modal.querySelector('.pn-rvm__x').focus();
  }
  function closeModal(){
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    document.documentElement.classList.remove('pn-rvm-open');
    if (typeof modal.__onClose === 'function') modal.__onClose();
    if (lastFocus && lastFocus.isConnected) lastFocus.focus();
  }

  /* ——— the teaser, in the page ——— */
  function Rotator(box, p){
    var i = 0, timer = null, playing = false;
    /* the sections now ship an empty mount, so the teaser is built in place —
       there is no legacy node to replace and nothing for PNQuotes to bind to */
    var fresh = box;
    fresh.classList.add('pn-rv-box');
    fresh.setAttribute('aria-label', 'Customer reviews');
    fresh.innerHTML =
      '<span class="' + p + '-quote-mark" aria-hidden="true">&#10077;</span>' +
      '<div class="' + p + '-quote-body">' +
        '<div class="pn-rv-live" aria-atomic="true" aria-live="off"></div>' +
        '<div class="pn-rv-bar">' +
          '<button class="pn-rv-btn" type="button" data-rv="prev" aria-label="Previous review">‹</button>' +
          '<button class="pn-rv-btn" type="button" data-rv="play" aria-pressed="false"></button>' +
          '<button class="pn-rv-btn" type="button" data-rv="next" aria-label="Next review">›</button>' +
          '<span class="pn-rv-pos" aria-hidden="true"></span>' +
        '</div>' +
      '</div>';

    var live = fresh.querySelector('.pn-rv-live'),
        posEl = fresh.querySelector('.pn-rv-pos'),
        playBtn = fresh.querySelector('[data-rv="play"]');

    function draw(){
      var r = DATA[i];
      /* the teaser is a button, not a link: it opens the review. The full text
         stays in the DOM and is clamped by CSS, so nothing is truncated for a
         screen reader and no ellipsis is invented. */
      live.innerHTML =
        '<button class="pn-rv-item" type="button" data-rv="open" aria-haspopup="dialog">' +
          '<span class="' + p + '-quote-text pn-rv-snip">' + esc(r.b) + '</span>' +
          '<span class="' + p + '-quote-cap pn-rv-cap">' +
            '<span class="pn-rv-stars" aria-hidden="true">' + stars(r.r) + '</span> ' + meta(r) +
          '</span>' +
          '<span class="pn-rv-sr"> — ' + (r.r|0) + ' out of 5 stars, opens the full review</span>' +
        '</button>';
      posEl.textContent = (i + 1) + ' / ' + DATA.length;
    }
    function show(n, announce){
      i = (n + DATA.length) % DATA.length;
      live.setAttribute('aria-live', announce ? 'polite' : 'off');
      draw();
    }
    function stop(){ if (timer) clearInterval(timer); timer = null; }
    function run(){ stop(); if (!reduce && playing && (!modal || modal.hidden)) timer = setInterval(function(){ show(i + 1, false); }, DWELL); }
    function setPlaying(v){
      playing = v;
      playBtn.textContent = v ? '❙❙' : '▶';
      playBtn.setAttribute('aria-pressed', v ? 'false' : 'true');
      playBtn.setAttribute('aria-label', v ? 'Pause the reviews' : 'Play the reviews');
      run();
    }

    fresh.addEventListener('click', function (e) {
      var b = e.target.closest('[data-rv]'); if (!b) return;
      var k = b.getAttribute('data-rv');
      if (k === 'open'){ stop(); openModal(DATA[i], b, run); return; }
      if (k === 'prev'){ show(i - 1, true); run(); }
      else if (k === 'next'){ show(i + 1, true); run(); }
      else setPlaying(!playing);
    });
    fresh.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft'){ e.preventDefault(); show(i - 1, true); run(); }
      if (e.key === 'ArrowRight'){ e.preventDefault(); show(i + 1, true); run(); }
    });
    fresh.addEventListener('mouseenter', stop);
    fresh.addEventListener('mouseleave', run);
    fresh.addEventListener('focusin', stop);
    fresh.addEventListener('focusout', function (e){ if (!fresh.contains(e.relatedTarget)) run(); });
    document.addEventListener('visibilitychange', function(){ document.hidden ? stop() : run(); });

    draw();
    setPlaying(!reduce);
  }

  /* the drawer's two figures, its stale CORS callback left holding detached nodes */
  function fixDrawerStats(){
    var rate = document.getElementById('pn-stat-rating'),
        desc = document.getElementById('pn-stat-review-desc');
    if (!rate && !desc) return;
    var n = parseInt(STATS.count, 10); if (isNaN(n)) n = DATA.length;
    var avg = parseFloat(STATS.rating);
    var five = DATA.filter(function (r){ return (r.r|0) === 5; }).length;
    function claim(el, text){
      if (!el) return;
      var f = el.cloneNode(false); f.removeAttribute('id'); f.textContent = text;
      el.parentNode.replaceChild(f, el);
    }
    claim(rate, isNaN(avg) ? '' : avg.toFixed(1));
    claim(desc, n + ' review' + (n === 1 ? '' : 's') + ' · ' +
      Math.round(five / DATA.length * 100) + '% five-star.');
  }

  function install(){
    var done = false;
    var mounts = document.querySelectorAll('[data-rv-mount]:not(.pn-rv-box)');
    Array.prototype.forEach.call(mounts, function (m) {
      Rotator(m, m.getAttribute('data-rv-mount') || 'pnsn');
      done = true;
    });
    fixDrawerStats();
    return done;
  }
  function boot(){
    install();
    var tries = 0, iv = setInterval(function () {
      install();
      if (++tries > 20) clearInterval(iv);
    }, 250);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
